import React from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Box, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import FlightSummaryForm from '../form/FlightSummaryForm';
import { useLocation } from 'react-router-dom';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CoupanModal from '../components/resuableComponents/CoupanModal';
import { useDispatch } from 'react-redux';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { setModal } from '../reducers/UiReducer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';

const steps = ['Review', 'Travel Detail', 'Payment'];

const FlightDetailPage = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	console.log('location', location);
	return (
		<div>
			<Navbar />
			<Box style={{ padding: 20 }}>
				<Stepper activeStep={1} alternativeLabel>
					{steps.map((label) => (
						<Step key={label}>
							<StepLabel
								sx={{
									'.MuiStepLabel-label': {
										// color: 'white',
									},
								}}>
								{label}
							</StepLabel>
						</Step>
					))}
				</Stepper>
			</Box>
			<Container style={{ marginTop: 10, marginBottom: 50 }}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={8}>
						{location?.state?.onward?.Supplier === 'TBO' &&
							location?.state?.onward?.Segments[0]?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
												</span>
											</Box>
											<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1 style={{ fontSize: matches ? 16 : 26 }}>
														{i.Origin.Airport.AirportCode}
													</h1>
													<span
														style={{
															fontSize: matches ? 16 : '24px',
															marginLeft: '12px',
														}}>
														{i.Origin.DepTime.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.DepTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.CityName}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1 style={{ fontSize: matches ? 16 : 26 }}>
														{i.Destination.Airport.AirportCode}
													</h1>
													<span
														style={{
															fontSize: matches ? 16 : '24px',
															marginLeft: '12px',
														}}>
														{i.Destination.ArrTime.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.ArrTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.CityName}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.CabinBaggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.onward?.Supplier === 'TBO' &&
							location?.state?.onward?.Segments.length > 1 &&
							location?.state?.onward?.Segments[1]?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
												</span>
											</Box>
											<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1 style={{ fontSize: 26 }}>
														{i.Origin.Airport.AirportCode}
													</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Origin.DepTime.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.DepTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.CityName}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1 style={{ fontSize: 26 }}>
														{i.Destination.Airport.AirportCode}
													</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Destination.ArrTime.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.ArrTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.CityName}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.CabinBaggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.onward?.Supplier === 'ETR' &&
							location?.state?.onward?.Segments?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline_Name} ${i.Airline_Code}-${i.Flight_Number}`}
												</span>
											</Box>
											<span>{`${i.Origin_City} to ${i.Destination_City}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.Origin}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Departure_DateTime.split(' ')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Departure_DateTime.split(' ')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin_City}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.Destination}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Arrival_DateTime.split(' ')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Arrival_DateTime.split(' ')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination_City}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin} to ${i.Destination}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Hand_Baggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.return?.Supplier === 'ETR' &&
							location?.state?.return?.Segments?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline_Code}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline_Name} ${i.Airline_Code}-${i.Flight_Number}`}
												</span>
											</Box>
											<span>{`${i.Origin_City} to ${i.Destination_City}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.Origin}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Departure_DateTime.split(' ')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Departure_DateTime.split(' ')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin_City}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.Destination}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Arrival_DateTime.split(' ')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Arrival_DateTime.split(' ')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination_City}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin} to ${i.Destination}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.Fares?.FareDetails[0]?.Free_Baggage?.Hand_Baggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.onward?.Supplier === 'TJK' &&
							location?.state?.onward?.sI?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.fD.aI.code}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.fD.aI.name} ${i.fD.aI.code}-${i.fD.fN}`}
												</span>
											</Box>
											<span>{`${i.da.city} to ${i.aa.city}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.da.code}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.dt.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.dt.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.da.city}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.aa.code}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.at.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.at.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.aa.city}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.da.code} to ${i.aa.code}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.iB}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.cB}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.return?.Supplier === 'TJK' &&
							location?.state?.return?.sI?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.fD.aI.code}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.fD.aI.name} ${i.fD.aI.code}-${i.fD.fN}`}
												</span>
											</Box>
											<span>{`${i.da.city} to ${i.aa.city}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.da.code}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.dt.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.dt.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.da.city}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.aa.code}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.at.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.at.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.aa.city}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.da.code} to ${i.aa.code}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.iB}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${location.state.onward?.totalPriceList?.fd?.ADULT?.bI.cB}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{location?.state?.onward?.Supplier === 'AIQ' && (
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}>
									<Box
										style={{
											display: 'flex',
											alignItems: 'center',
										}}>
										<img
											src={`https://nitish.musafirbazar.com/static/media/${
												location?.state?.onward?.flight_number?.split(' ')[0]
											}.gif`}
											style={{ height: 35 }}
										/>
										<span style={{ fontSize: 14, marginLeft: 10 }}>
											{`${location?.state?.onward?.airline} ${
												location?.state?.onward?.flight_number?.split(' ')[0]
											}-${
												location?.state?.onward?.flight_number?.split(' ')[1]
											}`}
										</span>
									</Box>
								</Box>

								<Box
									style={{
										padding: 20,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}>
									<Box>
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<h1>{location?.state?.onward?.origin}</h1>
											<span style={{ fontSize: '24px', marginLeft: '12px' }}>
												{location?.state?.onward?.departure_time}
											</span>
										</Box>
										<Box>
											<span style={{ fontSize: 12, color: 'grey' }}>
												{location?.state?.onward?.departure_date}
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
										</Box>
									</Box>
									<Box>
										<Box style={{ alignItems: 'center', textAlign: 'center' }}>
											<AccessTimeIcon />
											<h2>2hr 30mn</h2>
										</Box>
									</Box>
									<Box>
										<Box
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'end',
											}}>
											<h1>{location?.state?.onward?.destination}</h1>
											<span style={{ fontSize: '24px', marginLeft: '12px' }}>
												{location?.state?.onward?.arival_time}
											</span>
										</Box>
										<Box style={{ textAlign: 'end' }}>
											<span style={{ fontSize: 12, color: 'grey' }}>
												{location?.state?.onward?.arival_date}
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}></span>
										</Box>
									</Box>
								</Box>
							</Box>
						)}
						{location?.state?.return?.Supplier === 'TBO' &&
							location?.state?.return?.Segments[0]?.map((i) => {
								return (
									<Box
										style={{
											boxShadow: '0 0 10px rgba(0,0,0,.3)',
											backgroundColor: '#FFF',
											marginTop: 20,
											// padding: 10,
										}}>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box
												style={{
													display: 'flex',
													alignItems: 'center',
												}}>
												<img
													src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
													style={{ height: 35 }}
												/>
												<span style={{ fontSize: 14, marginLeft: 10 }}>
													{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
												</span>
											</Box>
											<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
										</Box>

										<Box
											style={{
												padding: 20,
												display: 'flex',
												justifyContent: 'space-between',
												alignItems: 'center',
											}}>
											<Box>
												<Box style={{ display: 'flex', alignItems: 'center' }}>
													<h1>{i.Origin.Airport.AirportCode}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Origin.DepTime.split('T')[1]}
													</span>
												</Box>
												<Box>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.DepTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Origin.Airport.CityName}
													</span>
												</Box>
											</Box>
											<Box>
												<Box
													style={{ alignItems: 'center', textAlign: 'center' }}>
													<AccessTimeIcon />
													<h2>2hr 30mn</h2>
												</Box>
											</Box>
											<Box>
												<Box
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'end',
													}}>
													<h1>{i.Destination.Airport.AirportCode}</h1>
													<span
														style={{ fontSize: '24px', marginLeft: '12px' }}>
														{i.Destination.ArrTime.split('T')[1]}
													</span>
												</Box>
												<Box style={{ textAlign: 'end' }}>
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.ArrTime.split('T')[0]}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.AirportName}
													</span>
													<br />
													<span style={{ fontSize: 12, color: 'grey' }}>
														{i.Destination.Airport.CityName}
													</span>
												</Box>
											</Box>
										</Box>
										<Box
											style={{
												backgroundColor: '#E1E1E1',
												color: 'rgba(0,0,0,.64)',
												padding: 10,
												display: 'flex',
												justifyContent: 'space-between',
											}}>
											<Box>
												<span style={{ fontSize: 14 }}>BAGGAGE</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CHECK-IN </span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.Baggage}`}</span>
											</Box>
											<Box>
												<span style={{ fontSize: 14 }}>CABIN</span>
												<br />
												<span
													style={{
														fontSize: 16,
														color: 'black',
													}}>{`${i.CabinBaggage}`}</span>
											</Box>
										</Box>
									</Box>
								);
							})}
						{matches ? (
							<>
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
										}}>
										<span>Offers</span>
									</Box>
									<Box
										onClick={() => dispatch(setModal(true))}
										style={{
											padding: 12,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											cursor: 'pointer',
										}}>
										<span style={{ fontSize: 16 }}>Have a coupan code ?</span>

										<ArrowForwardIosIcon
											style={{ fontSize: 16, color: 'orangered' }}
										/>
									</Box>
								</Box>
								<Box
									style={{
										boxShadow: '0 0 10px rgba(0,0,0,.3)',
										backgroundColor: '#FFF',
										marginTop: 20,
										// padding: 10,
									}}>
									<Box
										style={{
											backgroundColor: '#E1E1E1',
											color: 'rgba(0,0,0,.64)',
											padding: 10,
										}}>
										<span>Fare Summary</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Fare Type</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>
											Partially Refundable
										</span>
									</Box>
									<Box
										style={{
											padding: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<span style={{ fontSize: 12 }}>Base Fare</span>
										<span style={{ fontSize: 12, marginLeft: 10 }}>₹25150</span>
									</Box>
								</Box>
							</>
						) : (
							''
						)}
						<Box
							style={{
								boxShadow: '0 0 10px rgba(0,0,0,.3)',
								backgroundColor: '#FFF',
								marginTop: 20,
								padding: 10,
							}}>
							<FlightSummaryForm />
						</Box>
					</Grid>
					{matches ? (
						''
					) : (
						<Grid item xs={12} lg={4}>
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
									// padding: 10,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
									}}>
									<span>Offers</span>
								</Box>
								<Box
									onClick={() => dispatch(setModal(true))}
									style={{
										padding: 12,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										cursor: 'pointer',
									}}>
									<span style={{ fontSize: 16 }}>Have a coupan code ?</span>

									<ArrowForwardIosIcon
										style={{ fontSize: 16, color: 'orangered' }}
									/>
								</Box>
							</Box>
							<Box
								style={{
									boxShadow: '0 0 10px rgba(0,0,0,.3)',
									backgroundColor: '#FFF',
									marginTop: 20,
									// padding: 10,
								}}>
								<Box
									style={{
										backgroundColor: '#E1E1E1',
										color: 'rgba(0,0,0,.64)',
										padding: 10,
									}}>
									<span>Fare Summary</span>
								</Box>
								<Box
									style={{
										padding: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}>
									<span style={{ fontSize: 12 }}>Fare Type</span>
									<span style={{ fontSize: 12, marginLeft: 10 }}>
										Partially Refundable
									</span>
								</Box>
								<Box
									style={{
										padding: 10,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
									}}>
									<span style={{ fontSize: 12 }}>Base Fare</span>
									<span style={{ fontSize: 12, marginLeft: 10 }}>₹25150</span>
								</Box>
							</Box>
						</Grid>
					)}
				</Grid>
			</Container>
			<CoupanModal />
			<Footer />
		</div>
	);
};

export default FlightDetailPage;
